






import { Component, Vue } from 'vue-property-decorator';
import Menus from '@/parts/Menus'; // @ is an alias to /src

@Component({
  components: {
    Menus,
  },
})
export default class Home extends Vue {}
